import { StyledGrid } from './Grid.styles';

export default StyledGrid;
